import React from 'react'
 import './style.css'
function Hamburguer({ isOpen }) {
  return (
    <div className={`hamburger ${isOpen ? 'open' : ''}`}>
        <div className="burger burger1"></div>
        <div className="burger burger2"></div>
        <div className="burger burger2"></div>
    </div>
  )
}

export default Hamburguer